var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.23 10H18C13.5817 10 10 13.5817 10 18V22.24C10 26.6583 13.5817 30.24 18 30.24H22.23C26.6483 30.24 30.23 26.6583 30.23 22.24V18C30.23 13.5817 26.6483 10 22.23 10ZM16.12 14.12C17.2246 14.12 18.12 15.0154 18.12 16.12C18.12 17.2246 17.2246 18.12 16.12 18.12C15.0154 18.12 14.12 17.2246 14.12 16.12C14.12 15.0154 15.0154 14.12 16.12 14.12ZM23.51 28.12C26.3411 27.0627 28.2212 24.3621 28.23 21.34L28.2 19.62C28.2 19.21 28.12 18.44 28.12 18.44H26.49C22.7164 18.4515 19.2706 20.5862 17.58 23.96C16.3529 22.863 14.7659 22.2546 13.12 22.25H11.91C11.8207 24.5747 13.0834 26.7415 15.15 27.81C15.8888 28.2036 16.7129 28.4096 17.55 28.41H21.72C22.329 28.4187 22.9349 28.3206 23.51 28.12Z",
    fill: "#1B9075"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.033e441dbd7a00e87d6291da0bf5f7cb.svg";
export { ForwardRef as ReactComponent };